import React, { useEffect, useState } from "react";
import { CommonUtilities } from "../../../commonUtils";
import Header from "../../Header/header";
import { Modal } from 'react-responsive-modal';

export default function InternalProcess(subEntity: any) {
 
    let [activeMenu, setActiveMenu] = useState("InternalProcess");
    const onChangeMenu = (e: any) => {
        console.log(e)
        setActiveMenu(e)
    }

    return (

        <div className="ws-12 pm">

            <div className="ws-12 box">
                <div className="box-header well p0 pt prs">
                    <h2 className="ws-12 m0 pl full-width">
                        <i className="icon-file-add"></i> Process
                    </h2>
                </div>
                <div className="box-content">
                    <div className="row-fluid">
                        <div className="table-responsive_big">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Process</th>
                                        <th >Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Royalty Process</td>
                                        <td>
                                            <a ng-click="customInvPlg()" className="icon-btn primary"><i className="icon-play-outline"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

        </div>

    );
}
